import {HttpBaseService} from "./http-base.service";
import {HttpClient} from "@angular/common/http";
import {MessageService} from "./message.service";
import {firstValueFrom, Observable} from "rxjs";
import {Employee} from "../../models/Employee";
// eslint-disable-next-line @typescript-eslint/naming-convention
import Config from "../../config/Config";
import {inject, Injectable} from "@angular/core";
import {EnumMapper} from "./enumMapper.service";
import {AlertEnum} from "../../models/Enums/AlertEnum";
import {TranslateService} from "@ngx-translate/core";
import {Project} from "../../models/Project";
import {EmployeeFullName} from "../../models/EmployeeFullName";
import {Client} from "../../config/Client";
import {DivisionService} from "./division.service";

@Injectable({
	providedIn: "root",
})
export class GlobalSearchService extends HttpBaseService {
	public http = inject(HttpClient);
	messageService = inject(MessageService);
	private readonly translate = inject(TranslateService);
	private readonly divisionService = inject(DivisionService);

	errorMessageKey = "mep.services.employee.fetch-employees-failed";

	constructor() {
		super();
	}

	async getEmployeesWithKeyword(keyword: string, client: Client): Promise<Employee[]> {
		try {
			let employees = await firstValueFrom(
				this.http.get<Employee[]>(
					Config.services.global_search.baseUrl + Config.services.global_search.getEmployeesWithMsgUnit,
					{params: {keyword}},
				),
			);
			if (employees) {
				const result = EnumMapper.initialEnumMapperEmployee(employees, client, this.translate);
				await this.divisionService.setDivisionLabels(employees);
				return result;
			} else {
				return [];
			}
		} catch (e) {
			this._messageService.add(this.translate.instant(this.errorMessageKey), AlertEnum.DANGER);
		}
	}

	getProjectsWithKeyword(keyword: string): Observable<Project[]> {
		return this.http.get<Project[]>(Config.services.global_search.baseUrl + Config.services.global_search.getProjects, {
			params: {keyword},
		});
	}

	getProjectProposalsByKeyword(keyword: string): Observable<Project[]> {
		return this.http.get<Project[]>(
			Config.services.global_search.baseUrl + Config.services.global_search.getProjectProposalsByKeyword,
			{params: {keyword}},
		);
	}

	getEmployeeProposalsByKeyword(keyword: string): Observable<EmployeeFullName[]> {
		return this.http.get<EmployeeFullName[]>(
			Config.services.global_search.baseUrl + Config.services.global_search.getEmployeeProposalsByKeyword,
			{params: {keyword}},
		);
	}
}
